import api from './api';

const assetAcquisitionService = {
  // Get all acquisitions
  getAllAcquisitions: async (params = {}) => {
    try {
      const response = await api.get('/asset-acquisitions', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching asset acquisitions:', error);
      throw error;
    }
  },

  // Get acquisition by ID
  getAcquisitionById: async (id) => {
    try {
      const response = await api.get(`/asset-acquisitions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset acquisition:', error);
      throw error;
    }
  },

  // Create acquisition
  createAcquisition: async (data) => {
    try {
      const response = await api.post('/asset-acquisitions', data);
      return response.data;
    } catch (error) {
      console.error('Error creating asset acquisition:', error);
      throw error;
    }
  },

  // Update acquisition
  updateAcquisition: async (id, data) => {
    try {
      const response = await api.put(`/asset-acquisitions/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating asset acquisition:', error);
      throw error;
    }
  },

  // Delete acquisition
  deleteAcquisition: async (id) => {
    try {
      const response = await api.delete(`/asset-acquisitions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset acquisition:', error);
      throw error;
    }
  },

  // Get acquisition statistics
  getAcquisitionStats: async () => {
    try {
      const response = await api.get('/asset-acquisitions/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching asset acquisition statistics:', error);
      throw error;
    }
  },

  // Get next acquisition code
  getNextAcquisitionCode: async () => {
    try {
      const response = await api.get('/asset-acquisitions/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next acquisition code:', error);
      throw error;
    }
  }
};

export default assetAcquisitionService;
